
<div class="input-wrapper" [formGroup]="formGroup" [class.disabled]="disabled" [class.input-error]="f[controlName].invalid && f[controlName].touched" [class.arebic-content]="textDirection == 'rtl'">
    <!-- <span class="p-float-label p-input-icon-right"> -->
        <!-- -->
        <label class="w-100" [htmlFor]="id" translate>{{ label }}</label>
        <div class="p-inputgroup" dir="ltr">
            <span class="p-inputgroup-addon">
               <ng-content select="[addonContent]"></ng-content>
            </span>
            <input class="taly-input" 
                [formControlName]="controlName" 
                pInputText 
                appNumericOnly
                [attr.inputmode]="inputmodeType" 
                [id]="id" 
                [placeholder]="placeholderText" 
                type="text" 
                [value]="value" 
                #inputField  
                (change)="onChange(inputField.value)" 
                [disabled]="disabled"
                [maxlength]="max"
                [minlength]="min"
                [autofocus]="autofocus"
                pAutoFocus
            /> 
            <span class=" close-icon" *ngIf="!disabled">
                <i class="pi pi-times" (click)="onReset(inputField)" *ngIf="inputField.value"></i>
            </span>
        </div>      
       
    <!-- </span> -->
</div>
<div *ngIf="f[controlName].invalid && f[controlName].touched" class="alert">
    <span class="alert-danger" *ngIf="f[controlName].hasError('required')" >
        {{label | translate}} <span class="alert-danger" translate>COMMON.REQUIRED</span>
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && f[controlName]?.hasError('minlength')"> 
        <span class="alert-danger" translate [translateParams]="{min: min}">COMMON.MIN_LENGTH</span> {{label | translate}}
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && !f[controlName]?.hasError('minlength') && f[controlName]?.hasError('maxlength')">
        <span class="alert-danger" translate [translateParams]="{max: max}">COMMON.MAX_LENGTH</span> {{label | translate}}
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && !f[controlName]?.hasError('minlength') && !f[controlName]?.hasError('maxlength') && f[controlName]?.hasError('email')" translate>
        COMMON.INVALID_EMAIL
    </span>
    <span class="alert-danger" *ngIf="!f[controlName].hasError('required') && !f[controlName]?.hasError('minlength') && !f[controlName]?.hasError('maxlength') && !f[controlName]?.hasError('email') && f[controlName]?.hasError('pattern')">
        <span class="alert-danger" translate>COMMON.VALID_ENTER</span> {{label | translate}}
    </span>
</div>
